import { ReactNode } from 'react'

import { AstraChip, astraTwMerge } from '~/astra'

import { useEllipsis } from './useEllipsis'

const containerStyles = 'left-0 top-0 relative flex size-full flex-nowrap items-center gap-1 overflow-x-hidden border border-transparent px-2 py-3 transition'
const groupHoverStyles = `group-hover/ellipsis:absolute group-hover/ellipsis:h-fit group-hover/ellipsis:w-fit group-hover/ellipsis:z-elevated group-hover/ellipsis:mt-0.5 group-hover/ellipsis:flex-wrap group-hover/ellipsis:rounded-b group-hover/ellipsis:border-subtle group-hover/ellipsis:border-t-transparent group-hover/ellipsis:border-t-0 group-hover/ellipsis:bg-surface-base group-hover/ellipsis:shadow-lg`

type Props = {
    children: ReactNode[]
}

export const ChipEllipsis = ({ children }: Props) => {
    const { containerRef, countRef, displayedWidth, hiddenCount, maxItemWidth } = useEllipsis()

    return (
        <div className="group/ellipsis relative flex size-full items-center overflow-visible">
            <div ref={containerRef} className={astraTwMerge(containerStyles, hiddenCount > 0 ? groupHoverStyles : '')}>
                {children.map((child, index) => (
                    <div
                        key={index}
                        className={
                            hiddenCount > 0 && index >= children.length - hiddenCount
                                ? 'opacity-0 group-hover/ellipsis:!max-w-fit group-hover/ellipsis:opacity-100'
                                : ''
                        }
                        style={{ maxWidth: maxItemWidth }}
                    >
                        {child}
                    </div>
                ))}
            </div>
            <div
                ref={countRef}
                className={astraTwMerge(
                    'absolute flex h-full items-center p-2 transition',
                    hiddenCount === 0 ? 'hidden' : 'visible group-hover/ellipsis:hidden'
                )}
                style={{ left: displayedWidth }}
            >
                <AstraChip variant="filled" onClick={() => {}} label={`+${hiddenCount}`} />
            </div>
        </div>
    )
}
